import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from 'app/_controls/base.component';
import { MediaService } from 'app/_core/api-access/media.service';
import { AHICompany } from '../../../_core/models/company';




@Component({
  selector: 'app-company-review',
  templateUrl: './company-review.component.html'
})
export class CompanyReviewComponent  extends BaseComponent implements OnInit {
  @Input() company: AHICompany;

  public starNumbers = [5,4,3,2,1]

  constructor(
    private mediaService: MediaService) {
    super();
  }

  // Methods implement
  ngOnInit() {}

  getImageUrl(guid: string) {
    return this.mediaService.getImageUrl(guid);
  }
}
